// extracted by mini-css-extract-plugin
export default {"item":"RadioGroup_item__FQrdu","name":"RadioGroup_name__kUK5Y","radio-input":"RadioGroup_radio-input__wW2ni","customRadio":"RadioGroup_customRadio__5ul78"};